module.exports = __webpack_public_path__ + "media/img/frontend_application/delete-icon-5b3be10b0d7ae149ec60594f51e0144f.png";